import Vue from 'vue'

/**
 * 列表排序指令
 * 
 * 参数
 * arg:
 *   disabled - 是否启用排序
 * value:
 *   container - 排序区域的节点类型, default: 'table'
 *   itemPath - 排序区域(container) 和 排序项目(item) 之间的路径, 如 ol>div>li，路径为 "> div", default: ''
 *   item - 单个 item 的节点类型, default: 'tr'
 *   handleClass - 特定的可拖拽区域类名, default: ''
 *   placeholder - 拖动时占位的 dom 节点, default: '<div style="height: 40px;"/>'
 * 
 * 示例
 *  <table v-sortable:[disabled]="{ itemPath: '> tbody', handleClass: '.drag-handle' }" slot-scope="props" class="table">
        <thead>...</thead>
        <tbody is="table-body">
          // 拖拽的 item 需要配置 ID
          <tr v-for="tag in props.rows" :id="tag.id" :key="tag.id">
            <td is="table-column" v-if="isAppTagTab">
              // 如需指定可拖拽的区域需要使用参数 handleClass, 相应区域增加 class="class-name", 默认整个 item 可拖拽
              <img src="/icons/sort.svg" width="20" height="20" :class="isAppTagTab ? 'dragging' : ''" class="drag-handle" />
            </td>
            ...
 *
 */
Vue.directive('sortable', {
  bind(el, binding, vnode) {
    initSort(el, binding, vnode)
  },
  update(el, binding, vnode) {
    initSort(el, binding, vnode)
  }
})

/**
 * @param {Element} el 绑定的节点
 * @param {object} binding 指令传递的对象, 包括 value, arg 等属性
 * @param {object} vnode vnode节点
 */
function initSort(el, binding, vnode) {
  let oldIndex
  let value = binding.value || {}
  let disabled = binding.arg || false
  if (disabled) {
    // 禁用排序
    $(el).sortable('destroy')
  } else {
    // 启用排序
    let containerSelector = value.container || 'table'
    let itemPath = value.itemPath || ''
    let itemSelector = value.item || 'tr'
    let handle = value.handleClass || ''
    let placeholder = value.placeholder || '<div style="height: 40px;"/>'
    $(el).sortable({
      containerSelector: containerSelector,
      itemPath: itemPath,
      itemSelector: itemSelector,
      handle: handle,
      placeholder: placeholder,
      onDragStart: function(_item, container, _super) {
        oldIndex = _item.index()
        _item.appendTo(_item.parent())
        _super(_item, container)
      },
      onDrop: function(_item, container, _super) {
        let newIndex = _item.index()

        let ids = []
        let positions = []
        if (newIndex != oldIndex) {
          let items = _item.closest(containerSelector).find(`${itemPath} ${itemSelector}`)
          let length = items.length
          items.each(function(i, row) {
            ids[i] = $(row).prop('id')
            let row_index = i + 1
            positions[length - 1 - i] = row_index
          })
          vnode.context.$emit('on-drop', { ids: ids, positions: positions })
        }

        _super(_item, container)
      }
    })
  }
}
